import { ArrowUpRight } from "lucide-react";

export const NewsFeed = ({ items, onSelect }) => (
  <section className="container-x mt-24" data-testid="news-feed">
    <p className="eyebrow">Specials & news</p>
    <h2 className="mt-2 font-serif text-4xl text-ink sm:text-5xl">Offers worth packing for</h2>
    <div className="mt-10 grid gap-6 md:grid-cols-5">
      {items.map((n, k) => (
        <button key={n.id} onClick={onSelect}
          className={`group relative overflow-hidden rounded-3xl text-left ${k === 0 ? "md:col-span-3" : "md:col-span-2"}`}
          data-testid={`news-item-${n.id}`}>
          <img src={n.image} alt={n.title} className="h-[380px] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-shade/85 via-shade/20 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-8">
            <span className="rounded-full bg-gold px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-ink">{n.badge}</span>
            <h3 className="mt-4 flex items-center gap-2 font-serif text-3xl text-paper">
              {n.title}<ArrowUpRight className="h-5 w-5 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
            </h3>
            <p className="mt-2 max-w-md text-sm text-paper/80">{n.description}</p>
          </div>
        </button>
      ))}
    </div>
  </section>
);
